import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { navigableRoutes } from 'routes';
import config from 'config';
import { useUser } from 'context';
import { useConfig } from 'context/ConfigContext';

function Sidebar() {
  const user = useUser();
  const { getSetting } = useConfig();

  const showVoteButton = getSetting<boolean>('app.show_vote_button') === true;
  const voteButtonUrl = getSetting<string>('app.vote_button_url') || '';

  const routes = navigableRoutes
    .filter(route => route.path !== '/external/elecciones' || showVoteButton)
    .map(route => route.path === '/external/elecciones'
      ? { ...route, externalUrl: voteButtonUrl }
      : route);

  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const handleToggle = (path: string) => {
    setOpenMenus(prev => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  return (
    <div className="sidebar" data-color="black" data-active-color="info">
      <div className="logo">
        <a href="https://www.cokiba.org.ar/" className="simple-text" target="_blank" rel="noopener noreferrer">
          <div className="logo-img pr-2 pl-2">
            <img src={require('../../logo-40-white.png')} alt="COKIBA" />
          </div>
        </a>
        <div className="small text-right text-light font-weight-bold">
          v{ config.version }{ config.build ? '(' + config.build + ')' : '' }
          { config.env !== 'prod' ? ` - ${ config.env }` : '' }
        </div>
      </div>

      <div className="sidebar-wrapper">
        <ul className="nav">
          {routes.map((route, idx) => {
            if ('roles' in route && !user.is(route.roles)) {
              return;
            }

            const isVoteButton = route.path === '/external/elecciones';

            return (
              <li className="nav-item" key={route.path || idx}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {route.externalUrl !== undefined ? (
                    route.externalMethod === 'POST' ? (
                      <form
                        action={route.externalUrl}
                        method="POST"
                        target="_blank"
                        style={{ flex: 1, margin: 0 }}
                      >
                        <button
                          type="submit"
                          className="nav-link d-flex align-items-center"
                          style={{
                            flex: 1,
                            color: '#fff',
                            width: '-webkit-fill-available',
                            border: 0,
                            textAlign: 'left',
                          }}
                        >
                          {route.icon && <i className={route.icon} />}
                          <p>{route.displayName}</p>
                        </button>
                      </form>
                    ) : (
                      <a
                        href={route.externalUrl}
                        className={`nav-link d-flex align-items-center${isVoteButton ? ' vote-button' : ''}`}
                        style={{ flex: 1, color: isVoteButton ? '#412E01' : '#fff', width: '100%' }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {route.icon && <i className={route.icon} />}
                        <p>{route.displayName}</p>
                      </a>
                    )
                  ) : (
                    <NavLink
                      to={route.children ? '#' : route.path}
                      className="nav-link d-flex align-items-center"
                      activeClassName="active"
                      exact
                      style={{ flex: 1, color: '#fff', width: '100%' }}
                      onClick={() => handleToggle(route.path)}
                    >
                      {route.icon && <i className={route.icon} />}
                      <p>
                        {route.displayName}
                        {route.children && (
                          <span style={{ fontSize: '1rem', marginLeft: '0.25rem' }}>
                            {openMenus[route.path] ? '▾' : '▸'}
                          </span>
                        )}
                      </p>
                    </NavLink>
                  )}
                </div>

                {route.children && openMenus[route.path] && (
                  <ul className="nav pl-3" style={{ marginTop: '5px' }}>
                    {route.children.map((child, cidx) => (
                      <li className="nav-item" key={child.path || cidx}>
                        <NavLink
                          to={child.path}
                          className="nav-link"
                          activeClassName="active"
                          style={{ margin: '5px 0px 5px 25px', width: '85%' }}
                          exact
                        >
                          <p>{child.displayName}</p>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}


export default Sidebar;
